module.exports = __webpack_public_path__ + "name=img/src/assets/story/3.jpg?7c86ca0b12bc586c8558e96f3110498e";